import { useSelector } from 'react-redux';

import { getPublicPaymentOptions } from '@apis/payment';

import { UseAxiosQueryOptions, useAxiosQuery } from '@hooks/useAxiosQuery';

import { getCurrencyState, getCurrentSiteState } from '@redux/selectors';

import { Currency } from '@wegoTypes/currency';
import { CurrentSite } from '@wegoTypes/currentSite';

type GetHotelPublicPaymentOptionParams = {
  clientCode: 'bow_fli' | 'bow_hot';
};

export const getPublickPaymentOptionReviews = 'hotels-public-payment-option';

export const useGetHotelPublicPaymentOption = <TResult = Array<PublicPaymentOption>,>(
  params: GetHotelPublicPaymentOptionParams,
  options?: UseAxiosQueryOptions<Array<PublicPaymentOption>, TResult>,
) => {
  const apiBaseUrl = API_BASE_URL;
  const currency: Currency = useSelector(getCurrencyState);
  const currentSite: CurrentSite = useSelector(getCurrentSiteState);

  return useAxiosQuery({
    queryKey: [
      getPublickPaymentOptionReviews,
      {
        currencyCode: currency.code,
        currentSiteCode: currentSite.countryCode,
        ...params,
      },
    ],
    queryFn: () =>
      getPublicPaymentOptions(
        apiBaseUrl,
        params.clientCode,
        currency.code,
        currentSite.countryCode,
      ),
    ...options,
  });
};
